import { MapPin } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MapPinIcon = createLucideIcon(MapPin);
